<template>
  <div class="head-wrapper">
    <div class="title">{{ title}}</div>
    <slot />
  </div>
</template>

<script>
export default {
  props: {
    title: {
      required: true,
      type: String
    }
  }
}
</script>

<style lang="stylus" scoped>
.head-wrapper
  background-color #ffffff
  box-sizing border-box
  .title
    box-sizing: border-box;
    height .36rem
    margin 0 .12rem
    border-bottom .01rem solid #EBEBEB
    padding .07rem 0
    color #333333
    font-size .16rem
    font-weight 500
    font-family PingFangSC-Medium,PingFang SC
</style>